export default __webpack_public_path__ + "static/media/box.ddc4b9f1.webp";